import axios from 'axios';

import type {
  IUserTransferUserParams,
  IUserTransferUserResponse,
} from '@/app-package';

const requestUserTransfer = async ({
  outgoingTransferId,
}: IUserTransferUserParams) => {
  await axios.post<IUserTransferUserResponse>(
    `transfer/transfer_user/${outgoingTransferId}`,
  );
};

export default requestUserTransfer;
